const ListDiffs = () => import(/* webpackChunkName: "diff-group" */ '@/views/diff/ListDiffs')

export default [
  {
    path: 'diff',
    name: 'list-diffs',
    components: {
      studyContent: ListDiffs
    },
    meta: {
      title: '双录入差异比对'
    }
  }
]
